var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15V60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V45h15a15 15 0 0115 15v100a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5V60a5 5 0 00-5-5H80v12.93l8.54 8.53A5 5 0 0190 80v30a5 5 0 01-5 5h-5v25a5 5 0 01-10 0v-25h-5a5 5 0 01-5-5V80a5 5 0 011.46-3.54L70 67.93V55H55a5 5 0 00-5 5v100a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm-10-60h10V82.07l-5-5l-5 5zm10-60h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 100a5 5 0 01-5-5V80a5 5 0 0110 0v60a5 5 0 01-5 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.6f4253732b9a9b1876749869b2192505.svg";
export { ForwardRef as ReactComponent };